import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import axios from 'axios';
import { withRouter } from './withRouter';
import NavBar from './NavBar';



class ApplicationForm extends Component {

render() {
  return (
    <div>
      <NavBar />
      <h1>Start your application by submitting the form below.</h1> 
      <p>
        You will receive an email asking you to verify your email address.
        You will be able to log in and complete the application process when your email is verified.
        Our team will vet your application after you submit your application.
      </p>

      <Formik
        initialValues={{title: "",firstName: "",lastName: "", email: "",password: ""}}
        onSubmit={async (values, actions) => {
          try {
            console.log("Submitting form", values);

            const response = await axios.post(
              process.env.REACT_APP_API_URL + '/partner/public/applicant/add',
              values,
              {
                auth: {
                  username: 'agent',
                  password: 'afrika123'
                },
                headers: { "Content-Type": "application/json" }
              }
            );

            console.log("Success:", response.data);
            actions.resetForm();
            this.props.navigate(`/applicantformsuccesspage`);
          } catch (error) {
            console.log(error.response?.data);
          } finally {
            actions.setSubmitting(false);
          }
        }}
        validate={(values) => {
          let errors = {};

          if (!values.email) {
            errors.email = 'Required';
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = 'Invalid email address';
          }

          if (!values.password) {
            errors.password = 'Required';
          } else if (values.password.length < 8) {
            errors.password = 'Password too short';
          }

          if (!values.title) errors.title = 'Required';
          if (!values.firstName) errors.firstName = 'Required';
          if (!values.lastName) errors.lastName = 'Required';

          return errors;
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <label>Title:</label><br />
            <Field name="title" /><br />
            <ErrorMessage name="title" component="div" />

            <label>First Name:</label><br />
            <Field name="firstName" /><br />
            <ErrorMessage name="firstName" component="div" />

            <label>Last Name:</label><br />
            <Field name="lastName" /><br />
            <ErrorMessage name="lastName" component="div" />

            <label>Email:</label><br />
            <Field name="email" type="email" /><br />
            <ErrorMessage name="email" component="div" />

            <label>Password:</label><br />
            <Field name="password" type="password" /><br />
            <ErrorMessage name="password" component="div" />

            <button type="submit" disabled={isSubmitting}>
              Submit
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
}
export default withRouter(ApplicationForm);